import {BehaviorSubject} from "rxjs";
import {EventEmitter} from "@angular/core";
import {HttpParams} from "@angular/common/http";
import { IFilter } from "../../services/IFilter";
import { AuthService } from "../../services/auth.service";

export class EnvironmentFilter implements IFilter {
  anyChange:EventEmitter<any> = new EventEmitter<any>();

  constructor(private auth: AuthService) {
    this.clear();
  }

  nameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get name():any {
    return this.nameChange.value;
  }
  set name(name:any) {
    this.nameChange.next(name);
    this.emitChange("name", name);
  }

  codeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get code():any {
    return this.codeChange.value;
  }
  set code(code:any) {
    this.codeChange.next(code);
    this.emitChange("code", code);
  }

  descriptionChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get description():any {
    return this.descriptionChange.value;
  }
  set description(description:any) {
    this.descriptionChange.next(description);
    this.emitChange("description", description);
  }

  activeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get active():any {
    return this.activeChange.value;
  }
  set active(active:any) {
    this.activeChange.next(active);
    this.emitChange("active", active);
  }

  idChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get id():any {
    return this.idChange.value;
  }
  set id(id:any) {
    this.idChange.next(id);
    this.emitChange("id", id);
  }

  companyIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get companyId():any {
    return this.companyIdChange.value;
  }
  set companyId(companyId:any) {
    this.companyIdChange.next(companyId);
    this.emitChange("companyId", companyId);
  }

  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams():HttpParams {
    let params:HttpParams = new HttpParams();

    if (this.name && this.name !== '') {
      params = params.set("name", this.name);
    }

    if (this.code && this.code !== '') {
      params = params.set("code", this.code);
    }

    if (this.description && this.description !== '') {
      params = params.set("description", this.description);
    }

    if (this.active && this.active !== '') {
      params = params.set("active", this.active);
    }

    if (this.id && this.id !== '') {
      params = params.set("id", this.id);
    }

    if (this.companyId && this.companyId !== '') {
      params = params.set("companyId", this.companyId);
    }


    return params;
  }

  setFilters(props: any): void {
    this.nameChange.next(props.name || undefined);
    this.codeChange.next(props.code || undefined);
    this.descriptionChange.next(props.description || undefined);
    this.activeChange.next(props.active || undefined);
    this.idChange.next(props.id || undefined);
    this.companyIdChange.next(props.companyId === undefined ? this.auth.getCompanyId() : props.companyId || undefined);
  }

  toObj() {
    let obj:any = {};
    
    obj.name = this.name;
    obj.code = this.code;
    obj.description = this.description;
    obj.active = this.active;
    obj.id = this.id;
    obj.companyId = this.companyId;
  
    return obj;
  }


  public clear():void {
    this.name = undefined;
    this.code = undefined;
    this.description = undefined;
    this.active = undefined;
    this.id = undefined;
    this.companyId = this.auth.getCompanyId();
  }
}
